import React from 'react'
import logo from '../../img/pokestore.png'

const Header = () => {
    return (
        <header>
            <img src={logo} alt=''></img>
        </header>
    )
}

export default Header
